import { render, staticRenderFns } from "./ActionTakenTables.vue?vue&type=template&id=52d94ca1&"
import script from "./ActionTakenTables.vue?vue&type=script&lang=js&"
export * from "./ActionTakenTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports